import { render, staticRenderFns } from "./create_ic_zone.vue?vue&type=template&id=7a0b861a"
import script from "./create_ic_zone.vue?vue&type=script&lang=js"
export * from "./create_ic_zone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports